import BeSimpleAPI from '@/providers/api/';
import i18n from '@/plugins/i18n';

import { baseActions } from './../base_actions'
import { baseMutations } from './../base_mutations'

const state =
{
    api: new BeSimpleAPI(process.env.VUE_APP_FM_API_URL),
    'releases': {
        items: [],
        item: {}
    },
    'companies': {
        items: [],
        item: {},
        coupling: [
            { value: null, text: `--- ${i18n.t('management.kiesEenKoppeling')} ---` },
            { value: 'accountview', text: 'Accountview'},
            { value: 'afas', text: 'Afas' },
            { value: 'afas-online', text: 'Afas Online' },
            { value: 'alerterp', text: 'Alert ERP'},
            { value: 'baan', text: 'BAAN' },
            { value: 'csv', text: 'CSV' },
            { value: 'dummy', text: 'Dummy' },
            { value: 'eva', text: 'Eva' },
            { value: 'exact', text: 'Exact' },
            { value: 'cashflow', text: 'Cashflow' },
            { value: 'groenvision', text: 'GroenVision' },
            { value: 'groenvisionxml', text: 'GroenVisionXML' },
            { value: 'orderdirect', text: 'OrderDirect' },
            { value: 'king', text: 'KING' },
            { value: 'mamut', text: 'Mamut' },
            { value: 'minox', text: 'Minox' },
            { value: 'navision', text: 'Navision' },
            { value: 'orderdirect', text: 'OrderDirect' },
            { value: 'pakbon', text: 'Pakbon' },
            { value: 'prima', text: 'PRIMA' },
            { value: 'sapcsv', text: 'SAP CSV' },
            { value: 'snelstart_online', text: 'Snelstart Online' },
            { value: 'snelstartgateway', text: 'Snelstart Gateway' },
            { value: 'ubl', text: 'UBL' },
            { value: 'unit4', text: 'Unit4' },
            { value: 'unit4csv', text: 'Unit4Csv' },
            { value: 'werkexpert', text: 'WerkExpert' },
            { value: 'xml', text: 'XML' }
        ]
    },
    'price-agreements': {
        items: [],
        item: {}
    },
    'price-agreements-types': {
        items:[
            {
                id: '1',
                name: 'Licentie'
            },
            {
                id: '2',
                name: 'Onderhoud'
            }
        ],
        item: {}
    },
    'agreement-price': {
        items:[],
        item: {}
    },
    'price-agreements-customer': {
        items: [],
        item: {},
        path: function(params) {
            return `companies/${params.companyId}/price-agreements`;
        }
    },
    'invoices': {
        items: [],
        item: {},
        path: function(params) {
            return `companies/${params.companyId}`;
        }
    },
    'settings': {
        items: [],
        item: {},
        path: function(params) {
            return `companies/${params.companyId}/settings`;
        }
    },
    'reports': {
        items: [],
        item: {}
    }
}

const getters = {
    //List getters
    releases: state => state['releases'].items,
    customers: state => state['customers'].items,
    priceAgreements: state => state['price-agreements'].items,
    priceAgreementsTypes: state => state['price-agreements-types'].items,
    agreementPrices: state => state['agreement-price'].items,
    priceAgreementsCustomer: state => state['price-agreements-customer'].items,
    invoices: state => state['invoices'].items,
    settings: state => state['settings'].items,
    reports: state => state['reports'].items,
    companies: state => state['companies'].items,
    administrations: state => state['companies'].item.administrations,
    coupling: state => state['companies'].coupling,
    
    //Single getters
    release: state => state['releases'].item,
    customer: state => state['customers'].item,
    priceAgreement: state => state['price-agreements'].item,
    priceAgreementsType: state => state['price-agreements-types'].item,
    agreementPrice: state => state['agreement-price'].item,
    priceAgreementCustomer: state => state['price-agreements-customer'].item,
    invoice: state => state['invoices'].item,
    setting: state => state['settings'].item,
    report: state => state['reports'].item,
    company: state => state['companies'].item,
}

const actions = {
    ...baseActions
}

const mutations = {
    ...baseMutations
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}